import React from 'react';
import { Body, RawMoney } from '@edreamsodigeo/prisma-design-system';

export const PriceStyle = ({ money = {}, rounded }) => (
  <RawMoney currency={money.currency} rounded={rounded}>
    {money.amount}
  </RawMoney>
);

PriceStyle.Bold = ({ money = {}, rounded, color }) => (
  <Body weight="bold" color={color} inline>
    <RawMoney currency={money.currency} rounded={rounded}>
      {money.amount}
    </RawMoney>
  </Body>
);

PriceStyle.StrikeThrough = ({ money = {}, rounded, color = 'neutral.60' }) => (
  <Body textDecoration="line-through" color={color} inline>
    <RawMoney
      currency={money.currency}
      rounded={rounded}
      strikeThrough="default"
    >
      {money.amount}
    </RawMoney>
  </Body>
);
